import { LinearProgress } from '@mui/material';
import React from 'react';

export function ProgressIndicator({ progress }) {
  return <><LinearProgress variant="determinate" value={progress} />
    <h1>{progress + "%"}</h1></>;
}
